import { Link, useLocation, useParams } from 'react-router-dom';
import { UserLoginSection } from "../../components/Elements";

import Logo from '../../assets/logo_white.png'

export default function Header({ title }) {
    return (

        <header className='taskHeader'>
            <div className='mainWidth'>
                <Link to="/"><img className='logo' src={Logo} /></Link>
                <h5>{title}</h5>
                <UserLoginSection />
            </div>
        </header>
    )
}
